import {
  Modal,
  Form,
  Button,
  Row,
  InputGroup,
  Accordion,
} from "react-bootstrap";
import "../../../assets/scss/new-entity-modal.scss";
import Select from "react-select";
import CurrencyCustomInput from "../../utils/CurrencyCustomInput";
import NumberCustomInput from "../../utils/NumberCustomInput";
import DateTime from "react-datetime";
import { useAuth } from "../../../hooks/useAuth";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { queryActions } from "../../../utils/reactQueryActions";
import { useFormik } from "formik";
import { useEffect, useMemo, useState } from "react";
import * as yup from "yup";
import CreatableSelect from "react-select/creatable";
import ItemSizeDialog from "../../ItemSizeDialog";
import currency from "currency.js";
import moment from "moment";
import PurchaseDialog from "../../PurchaseDialog";
import { toast } from "react-toastify";
import NewVendorModal from "../../NewVendorModal";
import { useStoreActions, useStoreState } from "easy-peasy";
import {
  Units,
  allAcountDetailIDs,
  convertToBaseCurrency,
  fetchActionsUtil,
} from "../../../utils/helpers";
import { appSettings } from "../../../config";
import ConfirmDialog from "../../ConfirmDialogue";
import useDebounce, {
  useCurrencies,
  useIsAdmin,
  useTaxOptions,
  useUnits,
} from "../../../utils/hooks";
import ExpensesSelector from "../../utils/ExpensesSelector";
import { cloneDeep, isEmpty } from "lodash";
import { Popover } from "react-tiny-popover";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { FilesAttachments } from "../../../utils/Attachments";
import { UOMPicker } from "../../Inventory/UOMManagement";

const usageOptions = [
  {
    label: "Sales",
    value: "Sales",
  },
  {
    label: "Office Use",
    value: "Office Use",
  },
  {
    label: "Promo",
    value: "Promo",
  },
];

export default function AddNewStock({
  showCreateNewInventoryModal,
  setShowCreateNewInventoryModal,
  setItemType,
  refetch,
  printGRN,
}) {
  const { backendUrl, token } = useAuth();
  const [payment, setPayment] = useState({
    Payment: "Credit",
    From: "",
  });
  const queryClient = useQueryClient();
  const [showCreateNewVendorModal, setShowCreateNewVendorModal] = useState(
    false
  );
  const { Units, getUnitLabelByValue, getUnitsByUomById } = useUnits();

  // const [accountName, setAccountName] = useState("");

  const [accountses, setAccountses] = useState([]);

  const itemMeasurements = useStoreState(state => state.itemMeasurements);
  const setItemMeasurements = useStoreActions(
    actions => actions.setItemMeasurements
  );

  const { deploymentCurrencies: currenciesOptions } = useCurrencies();

  const generalSettings = useStoreState(state => state?.generalSettings);
  const taxOptions = useTaxOptions();

  const setUp = async department => {
    let response = await fetch(`${backendUrl}/api/items/set-up`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
        Authorization: `Bearer ${token}`,
      },
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const warehouses = await fetchActionsUtil(
      `${backendUrl}/api/warehouse/categories/${setItemType?.cater}`,
      "GET"
    );

    const storageLocation = await fetchActionsUtil(
      `${backendUrl}/api/StorageLocation/${setItemType?.whID}`,
      "GET"
    );

    // const singleWarehouse = await fetchActionsUtil(
    //   `${backendUrl}/api/warehouse/${setItemType?.namewh}`,
    //   "GET"
    // );

    const detailsAccount = await fetchActionsUtil(
      `${backendUrl}/api/accounts/accountDesc/FIXED ASSET`,
      "GET"
    );

    const currentAsset = await fetchActionsUtil(
      `${backendUrl}/api/accounts/accountDesc/CURRENT ASSET`,
      "GET"
    );

    //setAccountName(singleWarehouse?.warehouses[0]?.WH_Accounts?.Description);

    const { data } = await response.json();
    data.vendors = data?.vendors.map(el => ({
      label: el.CompanyName,
      value: el.Vendor_ID,
    }));
    data.itemMeasurement = data?.itemMeasurement.map(el => ({
      label: el.Size,
      value: el.Size,
    }));

    data.categories = data.categories.map(el => ({
      value: el.Cat_Name,
      label: el.Cat_Name,
    }));

    data.subCategories = data.subCategories.map(el => ({
      ...el,
      value: el.Sub_Cat,
      label: el.Sub_Cat,
    }));

    data.products = data.products.map(el => ({
      value: el.Product_Name,
      label: el.Product_Name,
    }));

    data.warehouses = warehouses?.warehouses
      ?.filter(e => e.W_ID === setItemType?.whID)
      ?.map(el => ({
        value: el.W_ID,
        label: el.W_name,
      }));

    data.storagelocation = storageLocation?.storagelocation?.map(el => ({
      value: el.Storage_ID,
      label: el.storage_location,
    }));

    const joins = [...detailsAccount.accountDes, ...currentAsset.accountDes];

    data.detailsAccount = [...new Set(joins?.map(d => d.AccountDesc))].map(
      el => ({
        value: el,
        label: el,
      })
    );

    // console.log(data);

    return data;
  };
  const {
    data = {
      vendors: [],
      itemMeasurement: [],
    },
  } = useQuery(["WAREHOUSE_ADD_NEW_ITEMS"], () => setUp(), {
    enabled: true,
  });

  const formik = useFormik({
    initialValues: {
      Vendor: "",
      Item_Type: "Inventory",
      Bar_Code: "",
      Item_Name: "",
      InvoiceNo: "",
      // Size: appSettings.isBatchStandard ? "" : "8 mm",
      // Unit: appSettings.isBatchStandard ? "Each" : "Tons",
      Size: "",
      Unit: "",
      Usage: "Sales",
      PurchasePrice: "",
      Freight: "",
      UnitCost: "",
      Quantity: 0,
      ExpireDate: moment(),
      Product_Name: "",
      Cat_Name: "",
      Branch: "HQ",
      Reorder_Level: "5",
      Tax: "",
      Warehouse: setItemType?.whID,
      StorageLocation: "",
      Date_Log: moment(),

      //--------
      DriverName: "",
      DriverPhoneNumber: "",
      TruckNumber: "",
      DeliveryDate: moment(),

      currency: generalSettings?.prevailingCurrency,
      conversionAmount: generalSettings.dollarInBaseCurrency,

      Incentive: 0,
      incentiveType: "Fixed",
      incentivePercentage: "",

      Margin: 0,
      marginType: "Fixed",
      marginPercentage: "",

      // ============
      openingAccountID: "300",
      openingAccountDescription: "Opening Balance Equity",
      openingAccountType: "OWNER'S EQUITY",
      Date_Log_Opened: new Date(),

      taxType: "None",
      deductTax: false,
      invoiceFiles: [],

      // ==========
      accountSelect: "",
      accountName: "",
      DetailType: "",
      Account_New_Name: "",
      savingType: "newItem",
      // ============
    },
    validationSchema: yup.object().shape({
      Bar_Code: yup.string().required("Item Code is required"),
      Item_Name: yup.string().required("Item Name is required"),
      // InvoiceNo: yup.string().required("Invoice number is required"),
      Product_Name: yup.string().required("required"),
      Cat_Name: yup.string().required("required"),
      // Vendor: yup.string().required("required"),
      PurchasePrice: yup.string().required("required"),
      // UnitPrice: yup.string().required("required"),
      Quantity: yup.string().required("required"),
      Warehouse: yup.string().required("required"),
      Unit: yup.string().required("required"),
      // StorageLocation: yup.string().required("required"),
    }),
    onSubmit: async values => {
      values = cloneDeep(values);
      values.vendorName = data?.vendors.find(
        el => el.value === values.Vendor
      )?.label;
      values.InvoiceAmount = InvoiceAmount;

      if (Number(values.Quantity) > 0 && !values.InvoiceNo && values.Vendor) {
        return formik.setFieldError("InvoiceNo", "Invoice number is required");
      }

      if (
        Number(values.Quantity) > 0 &&
        !values.Vendor &&
        !values.openingAccountID
      ) {
        return formik.setFieldError(
          "Vendor",
          "Select a vendor or an opening account"
        );
      }

      // we can generate InvoiceNo if it is not provided, since they did not pick a vendor
      if (!values.InvoiceNo && values.openingAccountID) {
        values.InvoiceNo = `${Date.now()}`;
      }

      const purchase = {
        Size: values.Size,
        Bar_Code: values.Bar_Code,
        UnitPrice: values.PurchasePrice,
        Quantity: values.Quantity,
        Vendor_ID: values.Vendor,
        AmountDue: values.InvoiceAmount,
        PurchaseID: String(Date.now()),
        PurchaseDate: values.Date_Log,
        InvoiceNo: values.InvoiceNo,
        ItemName: values.Item_Name,
        Branch: values.Branch,
      };

      values.totalLandingCost = totalLandingCost;

      const payload = {
        newItem: values,
        vendorName: values.vendorName,
        purchaseHistory: purchase,
        isBatchStandard: appSettings.isBatchStandard,
        vendorPaymentData: payment,

        // ========================================
        taxType: values.taxType,
        deductTax: values.deductTax,
        currencyCode: values.currency,
        conversionAmount: values.conversionAmount,
        requiresApproval:
          generalSettings?.newItemRequiresApproval && Number(InvoiceAmount) > 0,
        // ========================================
      };

      // ----------------------------------------------------------------------------------
      if (
        payload.newItem?.currency &&
        payload.newItem?.currency !== generalSettings?.prevailingCurrency
      ) {
        payload.newItem = convertToBaseCurrency({
          data: payload.newItem,
          conversionAmount: payload.newItem.conversionAmount,
        });

        payload.purchaseHistory = convertToBaseCurrency({
          data: payload.purchaseHistory,
          conversionAmount: payload.newItem.conversionAmount,
        });
      }
      //=====================================================================================

      // This api uses JSON, we do not want to change our structure, so we need to upload attachments first
      // before saving

      const handleUpload = async () => {
        if (!isEmpty(values.invoiceFiles)) {
          const uploadResponse = await uploadInvoiceMutation.mutateAsync({
            invoiceFiles: values.invoiceFiles,
            TransactionID: values.InvoiceNo,
          });
          payload.alreadyUploadedInvoiceAttachments =
            uploadResponse?.uploadData;
        }
      };

      // =================================================================================================================

      if (payload.requiresApproval) {
        if (
          await ConfirmDialog({
            title: "Send to Approval",
            description: `Are you sure you?`,
          })
        ) {
          await handleUpload();
          sendItemToApprovalMutation.mutate({
            ...payload,
          });
        }
      } else if (
        await ConfirmDialog({
          title: "Create New Item",
          description: `Are you sure you want to create this item`,
        })
      ) {
        await handleUpload();
        createMutation.mutate({
          ...payload,
        });
      }
    },
    onReset: () => {},
  });

  // GA ===============================================================
  const [showJournalPopover, setShowJournalPopover] = useState(false);
  const handleSelectedAccount = account => {
    // console.log(account);
    formik.setFieldValue("openingAccountID", account?.AccountID);
    formik.setFieldValue("openingAccountDescription", account?.Description);
    formik.setFieldValue("openingAccountType", account?.Type);
    setShowJournalPopover(false);
  };
  // ===================================================================

  const createItem = async payload => {
    let response = await fetch(`${backendUrl}/api/warehouse/stock`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };

  const createMutation = useMutation(payload => createItem(payload), {
    onSuccess: ({ message }) => {
      printGRN(formik.values.InvoiceNo);
      toast.success(message);

      formik.resetForm();
      if (refetch) refetch();
      setShowCreateNewInventoryModal(false);
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });

  const sendItemToApprovalMutation = useMutation(
    async payload => {
      const url = `${backendUrl}/api/warehouse/send-new-stock-to-approval`;

      let response = await fetch(url, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        response = await response.json();
        throw new Error(response.message);
      }
      const res = await response.json();
      return res;
    },
    {
      onSuccess: ({ message }) => {
        printGRN(formik.values.InvoiceNo);
        toast.success(message);

        formik.resetForm();
        if (refetch) refetch();
        setShowCreateNewInventoryModal(false);
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  const uploadInvoiceMutation = useMutation(
    async payload => {
      const formData = new FormData();
      formData.append(`TransactionID`, payload.TransactionID);

      if (payload?.invoiceFiles) {
        for (const file of payload?.invoiceFiles) {
          formData.append(`invoiceFiles`, file);
        }
      }
      const url = `${backendUrl}/api/invexcloud/upload-vendor-invoice-attachment`;

      let response = await fetch(url, {
        method: "POST",
        credentials: "include",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        response = await response.json();
        throw new Error(response.message);
      }
      const res = await response.json();
      return res;
    },
    {
      onSuccess: ({ message }) => {
        toast.success(message);
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  useEffect(() => {
    const UnitCost = currency(formik.values.PurchasePrice, {
      symbol: "",
      separator: "",
    })
      .add(formik.values.Freight)
      .format();
    formik.setFieldValue("UnitCost", UnitCost);
  }, [formik.values.PurchasePrice, formik.values.Freight]);

  const InvoiceAmount = useMemo(
    () =>
      currency(formik.values.PurchasePrice, {
        symbol: "",
        separator: "",
      })
        .multiply(formik.values.Quantity)
        .format(),
    [formik.values.PurchasePrice, formik.values.Quantity]
  );

  const taxValue = useMemo(() => {
    const taxType = taxOptions.find(el => el.value === formik.values.taxType);
    return currency(InvoiceAmount).multiply(taxType?.percentage).value;
  }, [InvoiceAmount, formik.values.taxType]);

  const InvoiceAmountTotal = useMemo(
    () =>
      currency(InvoiceAmount, {
        symbol: "",
      }).add(taxValue).value,
    [InvoiceAmount, taxValue]
  );

  const addItemMeasurement = async () => {
    const newSize = await ItemSizeDialog();
    if (newSize) {
      queryClient.setQueryData([queryActions.ITEMS_SETUP], data => {
        data.itemMeasurement = [
          ...data.itemMeasurement,
          { value: newSize.Size, label: newSize.Size },
        ];
        return data;
      });
      formik.setFieldValue("Size", newSize.Size);

      // add to store
      // console.log(newSize);
      setItemMeasurements([...itemMeasurements, newSize]);
    }
  };

  const setSelectedVendor = vendor => {
    if (vendor) {
      queryClient.setQueryData([queryActions.ITEMS_SETUP], data => {
        data.vendors = [
          ...data.vendors,
          { label: vendor.CompanyName, value: vendor.Vendor_ID },
        ];
        return data;
      });
      formik.setFieldValue("Vendor", vendor.Vendor_ID);
    }
  };

  const totalLandingCost = useMemo(() => {
    return currency(formik.values.UnitCost, {
      symbol: "",
      separator: "",
    })
      .multiply(formik.values.Quantity)
      .format();
  }, [formik.values.UnitCost, formik.values.Quantity]);

  const currencySymbol = useMemo(() => {
    const foundCurrency = currenciesOptions.find(
      el => el.cc === formik.values.currency
    );
    return foundCurrency ? foundCurrency.symbol : "";
  }, [formik.values.currency]);

  //For Incentive
  useEffect(() => {
    if (formik.values.markUpType === "Percentage") {
      formik.setFieldValue(
        "markUp",
        currency(formik.values.markUpPercentage)
          .divide(100)
          .multiply(formik.values.UnitCost).value
      );
    }

    if (formik.values.incentiveType === "Percentage") {
      formik.setFieldValue(
        "Incentive",
        currency(formik.values.incentivePercentage)
          .divide(100)
          .multiply(formik.values.markUp).value
      );
    }

    if (formik.values.marginType === "Percentage") {
      formik.setFieldValue(
        "Margin",
        currency(formik.values.marginPercentage)
          .divide(100)
          .multiply(formik.values.markUp).value
      );
    }
  }, [
    formik.values.UnitCost,
    formik.values.marginPercentage,
    formik.values.incentivePercentage,
    formik.values.marginType,
    formik.values.incentiveType,
    formik.values.markUp,
    formik.values.markUpType,
    formik.values.markUpPercentage,
  ]);

  useEffect(() => {
    if (appSettings.hasIncentive) {
      const UnitPrice = currency(formik.values.UnitCost)
        .add(formik.values.Incentive)
        .add(formik.values.Margin).value;

      formik.setFieldValue("UnitPrice", UnitPrice);
      formik.setFieldValue("Tax", UnitPrice);
      formik.setFieldValue("Vat_5", UnitPrice);
    }
  }, [formik.values.UnitCost, formik.values.Margin, formik.values.Incentive]);

  const debounceQty = useDebounce(formik.values.Quantity, 500);

  const getUniqueAccountId = async name => {
    let rangers = allAcountDetailIDs.filter(item => {
      if (item.data.some(d => d === name)) {
        return [item.num1, item.num2];
      }
    });
    let id = "";
    const res = await fetchActionsUtil(
      `${backendUrl}/api/accounts/generate-account-id`,
      "POST",
      "",
      { num1: rangers[0].num1, num2: rangers[0].num2 }
    );
    id = res.id;

    if (id === "") {
      getUniqueAccountId(name);
    } else {
      return id;
    }
  };

  const chooseCreateAccount = async () => {
    formik.setFieldValue("accountSelect", "CreateAccount");
    let id = await getUniqueAccountId("FIXED ASSET");
    formik.setFieldValue("accountName", id);
  };

  const chooseMapToAccount = async () => {
    formik.setFieldValue("accountSelect", "MapToAccount");
    formik.setFieldValue("accountName", "");
  };

  const getAccountDetailType = async desc => {
    const acc = await fetchActionsUtil(
      `${backendUrl}/api/accounts/accountDetailType/${desc}`,
      "GET"
    );

    const account = acc.accountDes.map(el => ({
      value: el.AccountID,
      label: el.Description,
    }));

    setAccountses(account);
  };

  return (
    <Modal
      show={showCreateNewInventoryModal}
      onHide={() => setShowCreateNewInventoryModal(false)}
      dialogClassName="new-entity-modal"
      backdropClassName={`global-backdrop`}
      centered={true}
      animation={false}
      enforceFocus={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1>Add New Product Information</h1>
          <p>Add a new item by filling in the following forms.</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-0">
        <Form
          noValidate
          onSubmit={formik.handleSubmit}
          className="row new-item-form w-100 m-0"
          autoComplete="off"
        >
          <div className="col-md-12 px-4">
            <Form.Label className="mb-2">Currency</Form.Label>
            <div className="d-flex gap-2  mb-3 pb-2">
              <Form.Group>
                <Select
                  classNamePrefix="form-select"
                  placeholder="Select Currency"
                  isSearchable={false}
                  options={currenciesOptions}
                  value={currenciesOptions.find(
                    el => el.value === formik.values.currency
                  )}
                  onChange={({ value }) => {
                    formik.setFieldValue("currency", value);
                  }}
                />
              </Form.Group>
              {formik.values.currency &&
              formik.values.currency !== generalSettings?.prevailingCurrency ? (
                <Form.Group>
                  <CurrencyCustomInput
                    currencySymbol={"Ex. Rate"}
                    name="conversionAmount"
                    value={formik.values.conversionAmount}
                    onValueChange={(value, name) => {
                      formik.setFieldValue(name, value);
                    }}
                    placeholder="0.00"
                  />
                </Form.Group>
              ) : null}
            </div>
          </div>

          {/*  */}

          <Form.Group className="mb-3 pb-2 px-4">
            <Form.Label className="mb-3">Account</Form.Label>
            <div className="d-flex gap-3 justify-content-between w-100">
              <Form.Check
                inline
                label="Map To Account"
                value="MapToAccount"
                name="accountSelect"
                type="radio"
                checked={formik.values?.accountSelect === "MapToAccount"}
                onChange={chooseMapToAccount}
                isInvalid={
                  formik.touched.accountSelect && !!formik.errors.accountSelect
                }
              />
              <Form.Check
                inline
                label="Create Account"
                value="CreateAccount"
                name="accountSelect"
                type="radio"
                onChange={chooseCreateAccount}
                checked={formik.values?.accountSelect === "CreateAccount"}
                isInvalid={
                  formik.touched.accountSelect && !!formik.errors.accountSelect
                }
              />
            </div>
          </Form.Group>

          <div className="row m-0">
            <Form.Group className="mb-3 col-6 px-4">
              <Form.Label className="mb-1">Account Detail Type</Form.Label>
              <Select
                classNamePrefix={"form-select"}
                value={data.detailsAccount?.find(
                  el => el.value === formik.values.DetailType
                )}
                onChange={({ value }) => {
                  formik.setFieldValue("DetailType", value);
                  getAccountDetailType(value);
                }}
                options={data.detailsAccount}
              />
              {formik.touched.DetailType && !!formik.errors.DetailType ? (
                <p className="custom-invalid-feedback">
                  {formik.errors.DetailType}
                </p>
              ) : null}
            </Form.Group>
            {formik.values.accountSelect === "CreateAccount" ? (
              <div className="mb-3 col-6 px-4">
                <Form.Group className="mb-3 pb-2">
                  <Form.Label className="mb-1">Account New Name</Form.Label>
                  <Form.Control
                    className=""
                    type="text"
                    placeholder="Enter Account New Name"
                    name="Account_New_Name"
                    value={formik.values.Account_New_Name}
                    onChange={formik.handleChange}
                    isInvalid={
                      formik.touched.Account_New_Name &&
                      !!formik.errors.Account_New_Name
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.Account_New_Name}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            ) : (
              <div className="mb-3 col-6 px-4">
                <Form.Label className="mb-1">Map to GL account</Form.Label>
                <div className="form-group">
                  <Select
                    closeMenuOnSelect={true}
                    value={accountses?.find(
                      el => el.value === formik.values.accountName
                    )}
                    onChange={selected => {
                      formik.setFieldValue("accountName", selected.value);
                    }}
                    options={accountses}
                  />
                  <span className="form-control-feedback text-danger">
                    {formik.errors.accountName}
                  </span>
                </div>
              </div>
            )}
          </div>

          {/*  */}

          <div className="col-md-6 px-4">
            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1">Item Code</Form.Label>
              <Form.Control
                className=""
                type="text"
                placeholder="Enter Item Code"
                name="Bar_Code"
                value={formik.values.Bar_Code}
                onChange={formik.handleChange}
                isInvalid={formik.touched.Bar_Code && !!formik.errors.Bar_Code}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.Bar_Code}
              </Form.Control.Feedback>
            </Form.Group>

            {/*  <Form.Group className=" mb-3 pb-2">
                <Form.Label className="mb-1">Amount Rcv</Form.Label>
                <Form.Control
                  className=""
                  type="text"
                  placeholder="Enter Amount Rcv"
                  name="username"
                />
                <Form.Control.Feedback type="invalid" />
              </Form.Group> */}

            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1">Item Name</Form.Label>
              <Form.Control
                className=""
                type="text"
                placeholder="Enter Item Name"
                name="Item_Name"
                value={formik.values.Item_Name}
                onChange={formik.handleChange}
                isInvalid={
                  formik.touched.Item_Name && !!formik.errors.Item_Name
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.Item_Name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1">Product</Form.Label>
              <CreatableSelect
                classNamePrefix={`form-select`}
                options={data.products}
                value={data?.products?.find(
                  el => el.value === formik.values.Product_Name
                )}
                onChange={({ value }) =>
                  formik.setFieldValue("Product_Name", value)
                }
              />
              {formik.touched.Product_Name && formik.errors.Product_Name ? (
                <span className="text-danger mt-2">
                  {formik.errors.Product_Name}
                </span>
              ) : null}
            </Form.Group>

            <Form.Group className=" mb-3 pb-2">
              <Form.Label className="mb-1">Category</Form.Label>
              <CreatableSelect
                classNamePrefix={`form-select`}
                options={data.categories}
                value={data?.categories?.find(
                  el => el.value === formik.values.Cat_Name
                )}
                onChange={({ value }) =>
                  formik.setFieldValue("Cat_Name", value)
                }
              />
              {formik.touched.Cat_Name && formik.errors.Cat_Name ? (
                <span className="text-danger mt-2">
                  {formik.errors.Cat_Name}
                </span>
              ) : null}
            </Form.Group>

            <Form.Group className="col-12 mb-3 pb-2">
              <Form.Label className="mb-1">Sub Category</Form.Label>
              <CreatableSelect
                classNamePrefix={`form-select`}
                options={data?.subCategories?.filter(
                  el => el?.Cat_Name === formik.values?.Cat_Name
                )}
                value={data?.subCategories
                  ?.filter(el => el?.Cat_Name === formik.values?.Cat_Name)
                  .find(el => el.value === formik.values.Sub_Cat)}
                onChange={({ value }) => formik.setFieldValue("Sub_Cat", value)}
              />
            </Form.Group>

            <div className="row text-nowrap align-items-center">
              <Form.Group className="col-12 mb-3 pb-2">
                <Form.Label className="mb-1">UOM</Form.Label>
                <UOMPicker
                  classNamePrefix={`form-select`}
                  value={formik.values.uomId}
                  onChange={selected => {
                    formik.setFieldValue("uomId", selected?.value || null);
                    formik.setFieldValue("baseUom", selected?.baseUom || "");
                    formik.setFieldValue("baseQty", selected?.baseQty || 1);
                    formik.setFieldValue("Unit", "");
                    formik.setFieldValue("Size", "");
                  }}
                />
                {formik.touched.uomId && !!formik.errors.uomId ? (
                  <span className="custom-invalid-feedback">
                    {formik.errors.uomId}
                  </span>
                ) : null}
              </Form.Group>
            </div>

            <div className="row text-nowrap align-items-center">
              <Form.Group className="col-5 mb-3 pb-2">
                <Form.Label className="mb-1">UOM to Stock</Form.Label>
                <Select
                  classNamePrefix={`form-select`}
                  // options={Units}
                  // value={Units.find(el => el.value === formik.values.Unit)}
                  // =========================================================

                  // UOM ID, ELSE FOR FALL BACK FOR OLD LOGIC
                  options={
                    formik.values.uomId
                      ? getUnitsByUomById({ uomId: formik.values.uomId })
                      : Units
                  }
                  value={(formik.values.uomId
                    ? getUnitsByUomById({ uomId: formik.values.uomId })
                    : Units
                  ).find(el => el.value === formik.values.Unit)}
                  onChange={selected => {
                    formik.setFieldValue("Unit", selected?.value);

                    if (!["Tons", "Pieces"].includes(selected?.value)) {
                      formik.setFieldValue("Size", "");
                    }
                  }}
                />
                {formik.touched.Unit && !!formik.errors.Unit ? (
                  <span className="custom-invalid-feedback">
                    {formik.errors.Unit}
                  </span>
                ) : null}
              </Form.Group>

              {["Tons", "Pieces"].includes(formik.values.Unit) && (
                <>
                  <Form.Group className="col-5 mb-3 pb-2">
                    <Form.Label className="mb-1">Size</Form.Label>
                    <Select
                      classNamePrefix={`form-select`}
                      options={data?.itemMeasurement}
                      value={data?.itemMeasurement.find(
                        el => el.value === formik.values.Size
                      )}
                      onChange={({ value }) =>
                        formik.setFieldValue("Size", value)
                      }
                    />
                  </Form.Group>

                  <Form.Group className="col-2 pb-2 px-0">
                    <Button size="sm" onClick={() => addItemMeasurement()}>
                      + Add
                    </Button>
                  </Form.Group>
                </>
              )}
            </div>

            <Form.Group className="mb-3 pb-2">
              <Form.Label>Quantity ({formik.values.Unit})</Form.Label>
              <NumberCustomInput
                placeholder="0"
                name="Quantity"
                value={formik.values.Quantity}
                onValueChange={(value, name) => {
                  formik.setFieldValue(name, value);
                }}
                isInvalid={formik.touched.Quantity && !!formik.errors.Quantity}
                onBlur={() => formik.setFieldTouched("Quantity", true)}
                // disabled={true}
              />
              {formik.touched.Quantity && !!formik.errors.Quantity ? (
                <span className="custom-invalid-feedback">
                  {formik.errors.Quantity}
                </span>
              ) : null}
            </Form.Group>

            {debounceQty > 0 ? (
              <div className="border p-3 mb-3 rounded-2">
                <Form.Group className="mb-3">
                  <Form.Label>Account to Credit</Form.Label>
                  <InputGroup hasValidation>
                    <Form.Control
                      placeholder="Select Account"
                      value={`${formik.values?.openingAccountID ||
                        ""} / ${formik.values?.openingAccountDescription ||
                        ""} / ${formik.values?.openingAccountType || ""}`}
                      onChange={() => {}}
                      readOnly
                    />

                    <Popover
                      isOpen={showJournalPopover}
                      onClickOutside={() => setShowJournalPopover(false)}
                      content={() => (
                        <ExpensesSelector
                          handleSelectedExpense={account => {
                            handleSelectedAccount(account);
                            formik.setFieldValue("Vendor", "");
                          }}
                          usage={"chart of accounts"}
                          onHide={() => setShowJournalPopover(false)}
                          Type="OWNER'S EQUITY"
                        />
                      )}
                      position="bottom"
                    >
                      <InputGroup.Text
                        onClick={() => setShowJournalPopover(true)}
                      >
                        <MagnifyIcon />
                      </InputGroup.Text>
                    </Popover>
                  </InputGroup>
                </Form.Group>
                <Form.Group className="col-6 mb-3 pb-2">
                  <Form.Label className="mb-1">As At</Form.Label>
                  <DateTime
                    dateFormat="MMM DD, YYYY"
                    timeFormat={false}
                    closeOnSelect={true}
                    closeOnClickOutside={true}
                    name="Date_Log_Opened"
                    inputProps={{
                      className: `date-input form-control ${
                        formik.touched.Date_Log_Opened &&
                        !!formik.errors.Date_Log_Opened
                          ? "is-invalid"
                          : ""
                      }`,
                      placeholder: "Select date",
                      readOnly: true,
                    }}
                    value={formik.values.Date_Log_Opened}
                    onChange={date => {
                      formik.setFieldValue("Date_Log_Opened", date, true);
                    }}
                    onBlur={() =>
                      formik.setFieldTouched("Date_Log_Opened", true)
                    }
                  />
                  {formik.touched.Date_Log_Opened &&
                  !!formik.errors.Date_Log_Opened ? (
                    <span className="custom-invalid-feedback">
                      {formik.errors.Date_Log_Opened}
                    </span>
                  ) : null}
                </Form.Group>{" "}
                <div className="d-flex align-items-center justify-content-between mb-3 gap-3">
                  <hr className="flex-grow-1" />
                  <p>Or</p>
                  <hr className="flex-grow-1" />
                </div>
                <div className="row text-nowrap align-items-center">
                  <Form.Group className="col-10 mb-3 pb-2">
                    <Form.Label className="mb-1">Vendor</Form.Label>
                    <Select
                      classNamePrefix={`form-select`}
                      options={data.vendors}
                      value={data?.vendors?.find(
                        el => el.value === formik.values.Vendor
                      )}
                      onChange={({ value }) => {
                        formik.setFieldValue("Vendor", value);

                        // Clear account user must pick either vendor or
                        handleSelectedAccount();
                      }}
                      isSearchable={true}
                    />
                    {formik.touched.Vendor && formik.errors.Vendor ? (
                      <span className="text-danger mt-2">
                        {formik.errors.Vendor}
                      </span>
                    ) : null}
                  </Form.Group>

                  <Form.Group className="col-2 pb-2 px-0">
                    <Button
                      size="sm"
                      onClick={() => setShowCreateNewVendorModal(true)}
                    >
                      + Add
                    </Button>
                  </Form.Group>
                </div>
                <Form.Group className="pb-2">
                  <Form.Label className="mb-1">Invoice No</Form.Label>
                  <Form.Control
                    className=""
                    type="text"
                    placeholder="Enter Invoice No"
                    name="InvoiceNo"
                    value={formik.values.InvoiceNo}
                    onChange={formik.handleChange}
                    isInvalid={
                      formik.touched.InvoiceNo && !!formik.errors.InvoiceNo
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.InvoiceNo}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
            ) : null}

            <div className="row">
              <Form.Group className="col-6 mb-3 pb-2">
                <Form.Label className="mb-1">Usage</Form.Label>
                <Select
                  classNamePrefix={`form-select`}
                  options={usageOptions}
                  value={usageOptions.find(
                    el => el.value === formik.values.Usage
                  )}
                  onChange={({ value }) => formik.setFieldValue("Usage", value)}
                />
              </Form.Group>
              <Form.Group className="col-6 mb-3 pb-2">
                <Form.Label className="mb-1">Creation Date</Form.Label>
                <DateTime
                  timeFormat={false}
                  closeOnSelect={true}
                  closeOnClickOutside={true}
                  dateFormat="MMM DD, YYYY"
                  inputProps={{
                    className: `date-input form-control`,
                    placeholder: "Select date",
                    readOnly: true,
                  }}
                  value={formik.values.Date_Log}
                  onChange={date => {
                    formik.setFieldValue("Date_Log", date, true);
                  }}
                />
              </Form.Group>
            </div>
            {/*  <Form.Group className=" mb-3 pb-2">
                <Form.Label className="mb-1">Item Description</Form.Label>
                <Form.Control
                  className=""
                  as="textarea"
                  placeholder=""
                  name="username"
                  rows={5}
                />
                <Form.Control.Feedback type="invalid" />
              </Form.Group> */}
          </div>

          <div className="col-md-6 px-4">
            <div className="row">
              <Form.Group className="col-md-6 mb-3 pb-2">
                <Form.Label className="mb-1">Purchase Price</Form.Label>
                <CurrencyCustomInput
                  currencySymbol={currencySymbol}
                  name="PurchasePrice"
                  placeholder="0.00"
                  value={formik.values.PurchasePrice}
                  onValueChange={(value, name) => {
                    formik.setFieldValue(name, value);
                  }}
                  isInvalid={
                    formik.touched.PurchasePrice &&
                    !!formik.errors.PurchasePrice
                  }
                  onBlur={() => formik.setFieldTouched("PurchasePrice", true)}
                />
                {formik.touched.PurchasePrice &&
                !!formik.errors.PurchasePrice ? (
                  <span className="custom-invalid-feedback">
                    {formik.errors.PurchasePrice}
                  </span>
                ) : null}
              </Form.Group>

              <Form.Group className="col-md-6 mb-3 pb-2">
                <Form.Label className="mb-1">Freight</Form.Label>
                <CurrencyCustomInput
                  currencySymbol={currencySymbol}
                  name="Freight"
                  placeholder="0.00"
                  value={formik.values.Freight}
                  onValueChange={(value, name) => {
                    formik.setFieldValue(name, value);
                  }}
                  isInvalid={formik.touched.Freight && !!formik.errors.Freight}
                  onBlur={() => formik.setFieldTouched("Freight", true)}
                />
                {formik.touched.Freight && !!formik.errors.Freight ? (
                  <span className="custom-invalid-feedback">
                    {formik.errors.Freight}
                  </span>
                ) : null}
              </Form.Group>

              {appSettings.hasIncentive ? (
                <>
                  {" "}
                  <Form.Group className="col-md-6 mb-3 pb-2">
                    <Form.Label className="mb-1">Profit</Form.Label>
                    <CurrencyCustomInput
                      currencySymbol={currencySymbol}
                      name="Margin"
                      placeholder="0.00"
                      value={formik.values.Margin}
                      onValueChange={(value, name) => {
                        formik.setFieldValue(name, value);
                      }}
                      isInvalid={
                        formik.touched.Margin && !!formik.errors.Margin
                      }
                      onBlur={() => formik.setFieldTouched("Margin", true)}
                    />
                    {formik.touched.Margin && !!formik.errors.Margin ? (
                      <span className="custom-invalid-feedback">
                        {formik.errors.Margin}
                      </span>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="col-md-6 mb-3 pb-2">
                    <Form.Label className="mb-1">Incentive</Form.Label>
                    <CurrencyCustomInput
                      currencySymbol={currencySymbol}
                      name="Incentive"
                      placeholder="0.00"
                      value={formik.values.Incentive}
                      onValueChange={(value, name) => {
                        formik.setFieldValue(name, value);
                      }}
                      isInvalid={
                        formik.touched.Incentive && !!formik.errors.Incentive
                      }
                      onBlur={() => formik.setFieldTouched("Incentive", true)}
                    />
                    {formik.touched.Incentive && !!formik.errors.Incentive ? (
                      <span className="custom-invalid-feedback">
                        {formik.errors.Incentive}
                      </span>
                    ) : null}
                  </Form.Group>
                </>
              ) : null}

              <Form.Group className="col-md-6 mb-3 pb-2">
                <Form.Label className="mb-1">
                  Unit Price (
                  {!["Tons", "Pieces"].includes(formik.values.Unit)
                    ? formik.values.Unit
                    : "Tons"}
                  )
                </Form.Label>
                <CurrencyCustomInput
                  currencySymbol={currencySymbol}
                  name="UnitPrice"
                  placeholder="0.00"
                  value={formik.values.UnitPrice}
                  onValueChange={(value, name) => {
                    formik.setFieldValue(name, value);
                  }}
                  isInvalid={
                    formik.touched.UnitPrice && !!formik.errors.UnitPrice
                  }
                  onBlur={() => formik.setFieldTouched("UnitPrice", true)}
                />
                {formik.touched.UnitPrice && !!formik.errors.UnitPrice ? (
                  <span className="custom-invalid-feedback">
                    {formik.errors.UnitPrice}
                  </span>
                ) : null}
              </Form.Group>

              {["Tons", "Pieces"].includes(formik.values.Unit) && (
                <Form.Group className="col-md-6 mb-3 pb-2">
                  <Form.Label className="mb-1">Unit Price (Piece)</Form.Label>
                  <CurrencyCustomInput
                    currencySymbol={currencySymbol}
                    name="Tax"
                    placeholder="0.00"
                    value={formik.values.Tax}
                    onValueChange={(value, name) => {
                      formik.setFieldValue(name, value);
                    }}
                    isInvalid={formik.touched.Tax && !!formik.errors.Tax}
                    onBlur={() => formik.setFieldTouched("Tax", true)}
                  />
                  {formik.touched.Tax && !!formik.errors.Tax ? (
                    <span className="custom-invalid-feedback">
                      {formik.errors.Tax}
                    </span>
                  ) : null}
                </Form.Group>
              )}

              <Form.Group className="col-md-6 mb-3 pb-2">
                <Form.Label className="mb-1">Unit Cost</Form.Label>
                <CurrencyCustomInput
                  currencySymbol={currencySymbol}
                  name="UnitCost"
                  placeholder="0.00"
                  value={formik.values.UnitCost}
                  onValueChange={(value, name) => {
                    formik.setFieldValue(name, value);
                  }}
                  isInvalid={
                    formik.touched.UnitCost && !!formik.errors.UnitCost
                  }
                  onBlur={() => formik.setFieldTouched("UnitCost", true)}
                />
                {formik.touched.UnitCost && !!formik.errors.UnitCost ? (
                  <span className="custom-invalid-feedback">
                    {formik.errors.UnitCost}
                  </span>
                ) : null}
              </Form.Group>

              {debounceQty > 0 ? (
                <div className="border row pt-4 mb-3 w-100 mx-auto rounded-2">
                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label className="fw-5">Tax</Form.Label>
                    <Select
                      classNamePrefix="form-select"
                      placeholder="Select"
                      isSearchable={false}
                      value={taxOptions.find(
                        el => el.value === formik.values.taxType
                      )}
                      options={taxOptions}
                      onChange={selected => {
                        formik.setFieldValue(
                          "taxType",
                          selected?.value || "None"
                        );
                      }}
                      isClearable
                    />
                  </Form.Group>

                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label className="fw-5">
                      {formik.values.taxType}
                    </Form.Label>
                    <CurrencyCustomInput
                      name="tax"
                      value={taxValue}
                      onValueChange={(value, name) => {}}
                      placeholder="0.00"
                    />
                  </Form.Group>

                  <Form.Label className="col-md-4 mb-3">
                    <Form.Label className="fw-5">&nbsp;</Form.Label>
                    <Form.Switch
                      type="switch"
                      className="custom-form-check"
                      label="Deduct Tax"
                      checked={formik.values.deductTax}
                      onChange={() =>
                        formik.setFieldValue(
                          "deductTax",
                          !formik.values.deductTax
                        )
                      }
                    />
                  </Form.Label>
                </div>
              ) : null}
            </div>

            <div className="row">
              <Form.Group className="col-md-6 mb-3 pb-2">
                <Form.Label title={totalLandingCost} className="mb-1">
                  Invoice Amount
                </Form.Label>
                <CurrencyCustomInput
                  currencySymbol={currencySymbol}
                  placeholder="0.00"
                  value={InvoiceAmount}
                  readOnly
                />
              </Form.Group>

              <Form.Group className="col-md-6 mb-3 pb-2">
                <Form.Label title={totalLandingCost} className="mb-1">
                  Total
                </Form.Label>
                <CurrencyCustomInput
                  currencySymbol={currencySymbol}
                  placeholder="0.00"
                  value={InvoiceAmountTotal}
                  readOnly
                />
              </Form.Group>
              {/*  <Form.Group className=" mb-3 pb-2">
                <Form.Label className="mb-1">Inventory Status</Form.Label>
                <Select classNamePrefix={`form-select`} />
                <Form.Control.Feedback type="invalid" />
              </Form.Group> */}

              {/* <Form.Group className="mb-3 pb-2">
                <Form.Label>QTY in Stock</Form.Label>
                <NumberCustomInput placeholder="0" name="qty" />
              </Form.Group> */}

              {/*  <Form.Group className=" mb-3 pb-2">
                <Form.Label className="mb-1">New Vendor</Form.Label>
                <Select classNamePrefix={`form-select`} />
                <Form.Control.Feedback type="invalid" />
              </Form.Group> */}

              {/*  <Form.Group className=" mb-3 pb-2">
                <Form.Label className="mb-1">Update Time</Form.Label>
                <Form.Control
                  defaultValue={format(new Date(), "do MM, yyy")}
                  readOnly
                />
                <Form.Control.Feedback type="invalid" />
              </Form.Group> */}

              <Form.Group className=" mb-3 pb-2">
                <Form.Label className="mb-1">Reorder Level</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Reorder Level"
                  name="Reorder_Level"
                  value={formik.values.Reorder_Level}
                  onValueChange={(value, name) => {
                    formik.setFieldValue(name, value);
                  }}
                />
              </Form.Group>
            </div>

            <div className="row">
              {/*   <Form.Group className="col-6 mb-3 pb-2">
                <Form.Label className="mb-1">Branch</Form.Label>
                <Form.Control defaultValue={formik.values.Branch} readOnly />
              </Form.Group> */}
              <Form.Group className="col-6 mb-3 pb-2">
                <Form.Label className="mb-1">Expire Date</Form.Label>
                <DateTime
                  timeFormat={false}
                  closeOnSelect={true}
                  closeOnClickOutside={true}
                  dateFormat="MMM DD, YYYY"
                  inputProps={{
                    className: `date-input form-control`,
                    placeholder: "Select date",
                    readOnly: true,
                  }}
                  value={formik.values.ExpireDate}
                  onChange={date => {
                    formik.setFieldValue("ExpireDate", date, true);
                  }}
                />
              </Form.Group>
            </div>

            <div className="row">
              <Form.Group className="col-6 mb-3 pb-2">
                <Form.Label className="mb-1">Warehouse</Form.Label>
                <CreatableSelect
                  classNamePrefix={`form-select`}
                  options={data.warehouses}
                  value={data?.warehouses?.find(
                    el => el.value === formik.values.Warehouse
                  )}
                  onChange={({ value }) =>
                    formik.setFieldValue("Warehouse", value)
                  }
                />
                {formik.touched.Warehouse && formik.errors.Warehouse ? (
                  <span className="text-danger mt-2">
                    {formik.errors.Warehouse}
                  </span>
                ) : null}
              </Form.Group>
              {/*  */}

              <Form.Group className="col-6 mb-3 pb-2">
                <Form.Label className="mb-1">Storage Location</Form.Label>
                <CreatableSelect
                  classNamePrefix={`form-select`}
                  options={data.storagelocation}
                  value={data?.storagelocation?.find(
                    el => el.value === formik.values.StorageLocation
                  )}
                  onChange={({ value }) =>
                    formik.setFieldValue("StorageLocation", value)
                  }
                  menuPlacement="top"
                />
                {formik.touched.StorageLocation &&
                formik.errors.StorageLocation ? (
                  <span className="text-danger mt-2">
                    {formik.errors.StorageLocation}
                  </span>
                ) : null}
              </Form.Group>

              <Accordion defaultActiveKey={[]} className="mb-3">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Delivery Information</Accordion.Header>
                  <Accordion.Body>
                    <Form.Group className="mb-3 pb-1">
                      <Form.Label className="mb-1">Driver</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Driver's Name"
                        name="DriverName"
                        value={formik.values.DriverName}
                        onChange={formik.handleChange}
                        maxLength={255}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3 pb-1">
                      <Form.Label className="mb-1">
                        Driver Phone Number
                      </Form.Label>
                      <Form.Control
                        type="tel"
                        placeholder="Enter Phone number"
                        name="DriverPhoneNumber"
                        value={formik.values.DriverPhoneNumber}
                        onChange={formik.handleChange}
                      />
                    </Form.Group>
                    <Row>
                      <Form.Group className="col mb-3 pb-1">
                        <Form.Label className="mb-1">Truck Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Truck Number"
                          name="TruckNumber"
                          value={formik.values.TruckNumber}
                          onChange={formik.handleChange}
                        />
                      </Form.Group>
                      <Form.Group className="col mb-3 pb-2">
                        <Form.Label className="mb-1">Date Delivered</Form.Label>
                        <DateTime
                          timeFormat={false}
                          closeOnSelect={true}
                          closeOnClickOutside={true}
                          dateFormat="MMM DD, YYYY"
                          inputProps={{
                            className: `date-input form-control`,
                            placeholder: "Select date",
                            readOnly: true,
                          }}
                          value={formik.values.DeliveryDate}
                          onChange={date => {
                            formik.setFieldValue("DeliveryDate", date, true);
                          }}
                        />
                      </Form.Group>
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              {formik.values.Vendor ? (
                <Form.Group className="mb-3">
                  <Form.Label className="mb-1" htmlFor="invoice-file">
                    Add Invoice
                  </Form.Label>

                  <FilesAttachments
                    url={formik.values.invoiceFiles}
                    files={formik.values.invoiceFiles}
                    colWidth={4}
                    setFiles={files =>
                      formik.setFieldValue("invoiceFiles", files)
                    }
                  />
                </Form.Group>
              ) : null}
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button
          onClick={() => formik.submitForm()}
          variant="primary"
          type="submit"
          className="w-50 submit-btn mt-3"
          disabled={
            createMutation.isLoading || uploadInvoiceMutation?.isLoading
          }
        >
          {createMutation.isLoading || uploadInvoiceMutation?.isLoading
            ? "Please wait..."
            : "Send To Inventory"}
        </Button>
      </Modal.Footer>

      {showCreateNewVendorModal && (
        <NewVendorModal
          showCreateNewVendorModal={showCreateNewVendorModal}
          setShowCreateNewVendorModal={setShowCreateNewVendorModal}
          setSelectedVendor={setSelectedVendor}
        />
      )}
    </Modal>
  );
}
